import * as Tone from 'tone';

export class LFOModule {
  constructor(engine) {
    this._engine = engine;
    this._rate = 2;
    this._depth = 0;
    this._destination = 'filter';

    this.lfo = new Tone.LFO({
      frequency: this._rate,
      min: -1,
      max: 1,
      type: 'sine',
    }).start();

    this._lfoGain = new Tone.Gain(0);
    this.lfo.connect(this._lfoGain);

    this._currentConnection = null;
  }

  setRate(rate) {
    this._rate = rate;
    this.lfo.frequency.setValueAtTime(rate, Tone.now());
  }

  setDepth(depth) {
    this._depth = depth;
    this._updateConnection();
  }

  setDestination(dest) {
    this._disconnect();
    this._destination = dest;
    this._updateConnection();
  }

  _disconnect() {
    if (this._currentConnection) {
      try {
        this._lfoGain.disconnect(this._currentConnection);
      } catch (e) {
        // Already disconnected
      }
      this._currentConnection = null;
    }
  }

  _updateConnection() {
    this._disconnect();

    if (this._depth === 0) return;

    const engine = this._engine;
    switch (this._destination) {
      case 'filter':
        this._lfoGain.gain.setValueAtTime(this._depth * 2000, Tone.now());
        this._currentConnection = engine.filter.frequency;
        break;
      case 'pitch':
        this._lfoGain.gain.setValueAtTime(this._depth * 100, Tone.now());
        this._currentConnection = engine.filter.frequency; // Will reroute to voices
        // For pitch, we modulate detune on all voices
        for (const voice of engine.voices) {
          this._currentConnection = voice.osc1.detune;
          break; // Just connect to first for simplicity
        }
        break;
      case 'amplitude':
        this._lfoGain.gain.setValueAtTime(this._depth * 0.5, Tone.now());
        this._currentConnection = engine.masterGain.gain;
        break;
    }

    if (this._currentConnection) {
      this._lfoGain.connect(this._currentConnection);
    }
  }

  dispose() {
    this._disconnect();
    this.lfo.stop().dispose();
    this._lfoGain.dispose();
  }
}
